<template>
    <el-popover
        ref="mass-expense-deal-edit"
        placement="top"
        title=""
        width="523"
        trigger="manual"
        v-model="showExpenseEdit"
        :visible-arrow="false"
        popper-class="mass-expense-deal-edit"
    >
        <el-row class="mb10">
            <el-col :span="24" class="label" v-if="issetCurrentExpenseId">
                <mass-expense-deal-edit
                    :id="currentExpenseId"
                    :deal-id="dealId"
                    @closePopUp="closePopUp"
                    @getDataFromServer="getDataFromServer"
                />
            </el-col>
        </el-row>
    </el-popover>
</template>

<script>
import '@/assets/styles/expense-deal-edit.scss';
import { mixin as clickaway } from 'vue-clickaway';
import MassExpenseDealEdit from '@/components/expenses/MassExpenseDealEdit.vue';

export default {
    name: 'MassExpenseDealEditPopup',
    mixins: [
        clickaway
    ],
    data() {
        return {
            showExpenseEdit: false,
            currentExpenseId: null
        };
    },
    props: {
        expenseId: {
            type: Number,
            default: 0
        },
        dealId: {
            type: Number,
            default: 0
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        MassExpenseDealEdit
    },
    computed: {
        issetCurrentExpenseId() {
            return +this.currentExpenseId > 0 || this.currentExpenseId === -1;
        }
    },
    methods: {
        closePopUp(value) {
            this.showExpenseEdit = value;
            this.currentExpenseId = null;
            this.$emit('changeVisibility', value);
        },
        hideForm(event) {
            if (this.showExpenseEdit && !event.target.classList.contains('spreadsheet-table-id-link')) {
                this.showExpenseEdit = false;
                this.currentExpenseId = null;
                this.$emit('changeVisibility', false);
            }
        },
        getDataFromServer() {
            this.$emit('getDataFromServer');
        }
    },
    watch: {
        isVisible(value) {
            this.showExpenseEdit = value;
        },
        expenseId(value) {
            this.currentExpenseId = value;
        }
    }
};
</script>
